import React, { createContext, useContext, useState, useEffect } from 'react';

const DensityContext = createContext();

export const useDensity = () => {
  return useContext(DensityContext);
};

export const DensityProvider = ({ children }) => {
  const [density, setDensity] = useState('medium');

  useEffect(() => {
    const updateDensity = () => {
      const width = window.innerWidth;
      if (width < 1200) {
        setDensity('medium');
      } else {
        setDensity('low');
      }
    };

    updateDensity();
    window.addEventListener('resize', updateDensity);
    return () => window.removeEventListener('resize', updateDensity);
  }, []);

  return (
    <DensityContext.Provider value={density}>
      {children}
    </DensityContext.Provider>
  );
};